
import Vue, { PropType } from "vue";

class Marker {
  id!: number;
  company?: string;
  address1?: string;
  address2?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  phone?: string;
  website?: string;
  position?: google.maps.LatLngLiteral;

  public constructor(init?: Partial<Marker>) {
    Object.assign(this, init);
  }
}
// Street line for a shop: "207 FRONT ST STE A". address2 is optional and the
// API sends it as undefined or "" when the shop has no suite/unit.
function buildStreetLine(marker: Marker): string {
  return [marker.address1, marker.address2].filter(Boolean).join(" ");
}

function buildInfoWindowContent(marker: Marker): string {
  return (
    "<div class='popper-info'><strong>" +
    marker.company +
    "</strong><br/>" +
    buildStreetLine(marker) +
    "<br/>" +
    marker.city +
    " " +
    marker.state +
    ", " +
    marker.postalCode +
    "<br/>" +
    marker.phone +
    '<br/><a href="' +
    marker?.website +
    '" target="_blank">' +
    marker?.website +
    "</a>" +
    "</div>"
  );
}

export default Vue.extend({
  props: {
    google: {
      type: Array as unknown as PropType<
        [
          google.maps.PlacesLibrary,
          google.maps.MapsLibrary,
          google.maps.CoreLibrary,
          google.maps.MarkerLibrary
        ]
      >,
      required: true,
    },
    map: {
      type: Object,
      required: true,
    },
    marker: {
      type: Object as PropType<Marker>,
      required: true,
    },
    info: {
      type: String,
      required: false,
      default: "",
    },
  },
  computed: {
    markerInfo(): string {
      return buildInfoWindowContent(this.marker as Marker);
    },
    iconUrl(): string {
      return this.$config.cdn + "bf-map-marker-blue.png";
    },
  },
  mounted() {
    const [PlacesLibrary, MapsLibrary, CoreLibrary, MarkerLibrary] =
      this.google;

    const { InfoWindow } = MapsLibrary;
    const { AdvancedMarkerElement } = MarkerLibrary;
    const mark1 = new AdvancedMarkerElement({
      position: this.marker.position,
      map: this.map,
      content: this.$el,
    });

    const infoWindow = new InfoWindow({
      content: this.markerInfo,
    });
    const _this = this;
    CoreLibrary.event.addListener(mark1, "click", function () {
      _this.map.setCenter(mark1.position);
      infoWindow.setContent(buildInfoWindowContent(_this.marker as Marker));
      infoWindow.open(_this.map, mark1);
    });
  },
});
